<script lang="ts">
import {defineComponent} from 'vue'
import GlobalButton from "@global/global-elements/global-button/global-button.vue";
import {mapGetters} from "vuex";
import GlobalLoadingOverlay from "@global/global-elements/global-loading-overlay/global-loading-overlay.vue";
import GlobalIcon from "@global/global-elements/global-icon/global-icon.vue";
import GlobalAnimatedIcon from "@global/global-elements/global-animated-icon/global-animated-icon.vue";

export default defineComponent({
    name: "MediaGalleryListActions",
    components: {GlobalAnimatedIcon, GlobalIcon, GlobalLoadingOverlay, GlobalButton},
    computed: {
        ...mapGetters({
            assets: 'getAssets',
            totalAssets: 'getTotalAssets',
            hasRunningRequests: 'hasRunningRequests'
        }),
        disableLoadMore() {
            return this.assets.length === this.totalAssets || this.hasRunningRequests
        }
    },
    methods: {
        handleLoadMore() {
            this.$store.dispatch('searchAssets', true)
        }
    }
})
</script>

<template>
    <span >
        <strong>{{assets.length}} {{$t('mediaGallery.loadMore.xOfY')}} {{totalAssets}}</strong>
        <global-button theme="secondary" :disabled="disableLoadMore" @click="handleLoadMore">{{$t('mediaGallery.loadMore.button')}}</global-button>
    </span>
</template>
